<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>
    
    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->
  
    <el-row class="ml-20 mr-20" v-if="!editMode">
      <el-col :xs="12" :sm="12" :lg="12">
        <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" >
        <el-button type="primary" @click.prevent="handleAdd" style="float: right;">新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
      </el-col>
    </el-row>

     



    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
      
    <el-row v-if="!editMode">
      <el-col :xs="24" :sm="24" :lg="24">
        <el-main class="mymain">
          <el-table class="mytable" :data="tableData" empty-text="無資料" stripe >
            
            <el-table-column prop="title" label="報價單號" width="120">
              <template slot-scope="scope">
                <router-link :to="`/daily/quotation/detail/${scope.row.id}`">{{ scope.row.quotationNo }}</router-link>
                <p class="mt-10">{{scope.row.status | poStatus}}</p>
              </template>
            </el-table-column>

            <el-table-column width="110" label="公司名稱" prop="customer.company"></el-table-column>
            <el-table-column width="80" label="客戶名稱" prop="customer.name"></el-table-column>

            
           
           
            <el-table-column label="操作" width="210">
              <template slot-scope="scope">
                <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="確定刪除此筆資料嗎?"
                    confirm-button-text="確定"
                    cancel-button-text="取消刪除"
                    icon="el-iconf-info"
                    icon-color="red"
                    @confirm="handleDelete(scope.row.id)"
                >
                  <el-button v-if="scope.row.status === 'draft'" type="danger" slot="reference" icon="el-icon-delete" circle ></el-button>
                </el-popconfirm>
                
                <el-popconfirm
                    class="ml-10 popconfirm-bg"
                    title="提醒，此價報單若進行修改，會需要重新送簽"
                    confirm-button-text="確定"
                    cancel-button-text="取消"
                    icon="el-iconf-info"
                    icon-color="red"
                    @confirm="handleReEdit(scope.row.id)"
                >
                  <el-button class="mr-10" v-if="scope.row.status === 'confirm' || scope.row.status === 'review'" type="info" slot="reference" icon="el-icon-edit" circle ></el-button>
                </el-popconfirm>

                

                <el-popconfirm
                    class="popconfirm-bg"
                    title="確定複製此筆資料嗎?"
                    confirm-button-text="確定"
                    cancel-button-text="取消"
                    icon="el-iconf-info"
                    icon-color="red"
                    @confirm="handleCopy(scope.row.id)"
                >
                  <el-button class="mr-10" v-if="scope.row.status !== 'draft'" type="primary" slot="reference" icon="el-icon-document-copy" circle ></el-button>
                </el-popconfirm>

                <el-popconfirm
                        class="popconfirm-bg"
                        title="確定註銷此筆資料嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消"
                        icon="el-iconf-info"
                        icon-color="red"
                        @confirm="handleCancel(scope.row.id)"
                    >
                      <el-button class="mr-10" v-if="scope.row.status !== 'draft' && scope.row.status !== 'cancel'" type="danger" slot="reference" 
                      icon="el-icon-folder-delete" circle ></el-button>
                    </el-popconfirm>
                


              </template>
            </el-table-column>




          </el-table>

          <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
            <el-pagination
                background
                layout="prev, pager, next"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </el-main>
      </el-col>
    </el-row>
    
    <el-row v-if="editMode">
      <el-main style="background-color: white;">
        <el-form class="myform" label-position="top"
                 :model="form"
                 :rules="rules"
                 ref="dataForm">

          <el-row>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="客戶" prop="custId">
                 <el-autocomplete
                  class="inline-input full-width-input"
                  v-model="form.custLabel"
                  :fetch-suggestions="querySearch"
                  placeholder="輸入客戶名稱"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item label="日期" prop="qDate">
                <el-input readonly v-model="form.quotationDate" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-checkbox v-model="addCustomerCheckbox">若查無客戶，勾選此做新增</el-checkbox>

            <el-form-item prop="manualAddCustomerName">
              <el-input class="mt-10" v-if="addCustomerCheckbox" v-model="form.manualAddCustomerName" placeholder="請輸入客戶公司名"></el-input>
            </el-form-item>
            
          </el-col>
        </el-row>



        </el-form>

        <div class="dialog-footer mt-20">
          <el-button @click="editMode = false">取 消</el-button>
          <el-button type="primary" @click="saveData('dataForm')">下一步</el-button>
        </div>
      </el-main>
    </el-row>
    


    



    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    


      <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">

        <div>
          <el-select v-model="queryField" placeholder="選擇搜尋條件" style="padding: 0 0 0 10px">
          <el-option
              v-for="item in filterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>

        <el-input v-model="keyword" style="width: 240px" placeholder="輸入關鍵字" class="ml-10 mt-10"
                  suffix-icon="el-icon-search"></el-input>

        <el-button type="primary" @click.prevent="search" class="ml-10 mt-10">查詢</el-button>
        <el-button type="normal" @click.prevent="clearQuery" class="ml-10 mt-10">清除條件</el-button>
        </div>
      </el-drawer>
      
    </el-row>
  </div>

</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import dayjs from "dayjs"


export default {
  name: "Quotation",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      console.log('custId:', value, ":", this.addCustomerCheckbox)
      if (this.addCustomerCheckbox === false) {
        if (value === 0) {
          callback(new Error('請選客戶'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    let checkCustomerName = (rule, value, callback) => {
      //console.log('checkCustomerName:', this.addCustomerCheckbox)
      if (this.addCustomerCheckbox === true) {
        if (value === '') {
          callback(new Error('請輸入客戶公司名'))
        } else {
          callback()
        }  
      } else {
        callback()
      }
    }

    return {
      editMode: false,
      drawer: false,
      direction: 'ltr',

      dw: '40%',
      dialogFormVisible: false,
      filterOptions: [{
        value: 'name',
        label: '公司名或聯絡人'
      }],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 15,
      total: 0,
      tableData: [],
      options: [],
      
      addCustomerCheckbox: false,
        
      form: {
        quotationDate: '',
        custId: 0,
        custLabel: '',
        manualAddCustomer: 'N',
        manualAddCustomerName: ''
      },

      rules: {
        custId: [{required: true, validator: checkName, trigger: 'change'}],
        manualAddCustomerName: [{required: true, validator: checkCustomerName, trigger: 'change'}],
      }
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {
    handleClose(){
      this.drawer = false
    },
    querySearch(str, cb){
      
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {

          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleSelect(item) {
      this.form.custId = item.id
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadMyQuotation()
    },
    closeDialog() {

    },
    search() {
      this.drawer = false
      this.loadMyQuotation()
    },
    clearQuery() {
      this.drawer = false
      this.keyword = ''
      this.queryField = ''
      this.loadMyQuotation()
    },
    handleAdd() {
      this.editMode = true

      //this.dialogFormVisible = true
      this.form.quotationDate = dayjs().format("YYYYMMDD")


    },
    handleDelete(id) {
      this.request.delete(`/quotation/${id}`).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadMyQuotation()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    handleCopy(id) {
      let no = dayjs().format("YYYYMMDD")
      this.request.post(`/quotation/copy?id=${id}&no=${no}`).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料複製成功.')
          this.loadMyQuotation()
        } else {
          this.showResult('error', '資料複製失敗.')
        }
      })
    },
    handleCancel(id) {
      this.request.post(`/quotation/cancel/${id}`).then(res => {
        if (res.code === '200') {
          this.showResult('success', '報價單註銷成功.')
          this.loadMyQuotation()
        } else {
          this.showResult('error', '報價單註銷失敗.')
        }
      })
    },
    
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      console.log('windowSize:', windowSize)
      const defaultWidth = '400'; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "40%"
      }
    },
    loadMyQuotation() {
      console.log('loadMyQuotation')
      this.request.get(`/quotation/my?pageNum=${this.pageNum}&pageSize=${this.pageSize}&queryField=${this.queryField}&keyword=${this.keyword}`).then(res => {
        if (res.code === '200') {
          this.tableData = res.data.records
          this.total = res.data.total
        } else {
          this.total = 0
          this.tableData = []
          this.showResult('error', 'load_my_quotation_failed')
        }
      })
    },
    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    saveData(formName) {
      
      if (this.addCustomerCheckbox) {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            if (this.addCustomerCheckbox) {
              this.form.manualAddCustomer = 'Y'
            } else {
              this.form.manualAddCustomer = 'N'
            }
            this.request.post("/quotation/init", this.form).then(res => {
              this.$router.push("/daily/quotation/detail/" + res.data.id)
            })
          }
        })
        
      } else {
        this.$refs[formName].validate(async valid => {
          if (valid) {
            if (this.addCustomerCheckbox) {
              this.form.manualAddCustomer = 'Y'
            } else {
              this.form.manualAddCustomer = 'N'
            }
            this.request.post("/quotation/init", this.form).then(res => {
              this.$router.push("/daily/quotation/detail/" + res.data.id)
            })
          }
        })
      }
    },

    handleReEdit(id){
      this.request.post(`/quotation/draft/${id}`).then(res => {
        if (res.code === '200') {
          this.$router.push("/daily/quotation/detail/" + res.data.id)
        }
      })
    }
  },
  filters: {
    fmtDate(value) {
      return dayjs(value).format("YYYY-MM-DD HH:mm")
    }
  },
  mounted() {
    //撈我負責的客戶
    //this.loadMyCustomer()

    this.loadMyQuotation()

    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.full-width-input {
  width: 95%;
  max-width: 100%;
}
.myform >>> .el-form-item__label {
  padding: 0;
}
.mymain {
  padding: 20px 4px;
}
.mytable {
  padding: 10px;
}

</style>
